import request from './core/request'

// 商家相关API
export default {
	//获取商家列表
	getStoreList: (params) => request.get('/store/store', params, {
		needAccessToken: false,
	}),
	//获取商家详情
	getStoreDetail: (id) => request.get(`/store/store/get/detail/${id}`, {}, {
		needAccessToken: false,
	}),
	//获取品牌列表
	getBrandList: () => request.get(`/goods/goods/brands`, {}, {
		needAccessToken: false,
	}),
	//通过商家ID获取商家商品分类
	getStoreCategory: (storeId) => request.get(`/store/store/label/get/${storeId}`, {}, {
		needAccessToken: false,
	})	
}